import { is } from 'ramda'

export function isObject(obj: any) {
  return is(Object, obj) && !is(String, obj) && typeof obj !== 'function'
}
